import { useTranslation } from 'react-i18next'
import { Stamp } from '@/components/ui/Stamp'
import type { TournamentStatus } from '@brochure/shared'

const TONES: Record<TournamentStatus, 'sun' | 'coral' | 'ink'> = {
  registration: 'sun',
  closed: 'ink',
  active: 'coral',
  completed: 'ink',
}

type StatusStampProps = { status: TournamentStatus; className?: string }

/** Timbro dello stato del torneo: colore e testo secondo il ciclo di vita (iscrizioni → chiuso → in corso → concluso). */
export function StatusStamp({ status, className }: StatusStampProps) {
  const { t } = useTranslation()
  return (
    <Stamp tone={TONES[status]} className={className}>
      {t(`stoccoPong.status.${status}`)}
    </Stamp>
  )
}
